module.exports = __webpack_public_path__ + "static/media/Conventional.e8cfca49.svg";